import { render, staticRenderFns } from "./inOutStatistic.vue?vue&type=template&id=0b94011c&scoped=true"
import script from "./inOutStatistic.vue?vue&type=script&lang=js"
export * from "./inOutStatistic.vue?vue&type=script&lang=js"
import style0 from "./inOutStatistic.vue?vue&type=style&index=0&id=0b94011c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b94011c",
  null
  
)

export default component.exports